import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import authActions from '#redux/Auth/actions';
import LocalStorage from '#services/LocalStorageService';
import { removeAuthHeader } from '#config/api';
import { getErrorRedirectURL } from '#screens/LoginRedirect/utils';

export const useLogout = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();
  const handleLogout = () => {
    removeAuthHeader();
    LocalStorage.removeTokenManager();
    dispatch(authActions.logout(() => logout({ returnTo: getErrorRedirectURL('') })));
  };

  return handleLogout;
};
